import { render } from "./TestimonialModal.vue?vue&type=template&id=f405d0de&scoped=true"
import script from "./TestimonialModal.vue?vue&type=script&lang=js"
export * from "./TestimonialModal.vue?vue&type=script&lang=js"

import "./TestimonialModal.vue?vue&type=style&index=0&id=f405d0de&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f405d0de"]])

export default __exports__